<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KLfKMo/tc-custom/9781429986342.jpg?1720011210787" alt="This image is the cover for the book Gatecrasher"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gatecrasher
      </h1>
      <p class="bookDescription body article font2">
        <b>A gold digger woos a widower in a “modern day novel of manners . . . [with] memorable characters . . . as unpredictable and multifaceted as they are stylish” (<i>Publishers Weekly</i>).</b><br/><br/>Madeleine Wickham is Sophie Kinsella, and The Gatecrasher is just as delicious as her internationally bestselling Shopaholic series.<br/><br/>Everything’s coming up roses for Fleur Daxeny, as she goes through more rich men than she does designer hats. Beautiful and utterly irresistible, her success at crashing funerals to find wealthy men is remarkable. Fleur wastes no time in seducing her latest conquest, the handsome and rich widower Richard Favour. His children are caught up in a whirlwind as their father’s new girlfriend descends on the family estate. Fleur is not one to wear her heart on her Chanel sleeves, but she soon finds herself embracing Richard and his family. But just as Fleur contemplates jumping off the gold-digger train for good, a long-buried secret from her past threatens to destroy her new family.<br/><br/>“Witty and deeply biting. . . . Wickham’s characters move with the studied grace of Jane Austen’s upper class. . . . Readers will be both touched and entertained.” —<i>Library Journal</i><br/><br/>“An observant and engaging storyteller.” —<i>Kirkus Reviews</i><br/><br/>“An enjoyable read.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Madeleine Wickham
      </h2>
      
      <p class="authorDescription body article"><P><B>Madeleine Wickham</B> is the author of several acclaimed novels, including <I>A Desirable Residence</I>, <I>Cocktails for Three</I>, <I>Sleeping Arrangements</I> and <I>The Wedding Girl</I>. As Sophie Kinsella, she has written a number of bestsellers including the Shopaholic series, <I>Twenties Girl</I>, <I>Remember Me?,</I><I>The Undomestic Goddess</I>, and <I>Can You Keep a Secret?</I><I>Confessions of a Shopaholic</I> was made into a major motion picture starring Isla Fisher and Hugh Dancy. Born in London, Wickham studied at New College, Oxford. She lives in London with her husband and family.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ffc86ffc